var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('nuxt-link',{staticClass:"z-btn inline-flex h-8 items-center justify-center space-x-1 whitespace-nowrap rounded-sm px-4 py-1 text-xs font-medium leading-loose transition-colors duration-300 ease-in-out focus:outline-none",class:[_vm.colors],attrs:{"to":_vm.to}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }